import Link from "next/link";
import { classNames } from "../../lib/utils";
import { isCurrent } from "./ManagerNavigation";
import { useRouter } from "next/router";
import { CalendarIcon } from '@heroicons/react/24/outline'

const ManagerNavigation = () : JSX.Element => {
  const router = useRouter()
  
  return (
    <div data-testid='commish-navigation'>
      <Link
        href='/seasons'
        passHref                            
      >
        <a
          className={classNames(
            (isCurrent(['/seasons'], router.pathname))
              ? 'bg-gray-900 text-white'
              : 'text-gray-300 hover:bg-gray-700 hover:text-white',
            'group flex items-center px-2 py-2 text-base font-medium rounded-md cursor-pointer',
          )}
        >
          <CalendarIcon
            className={classNames(
              isCurrent(['/seasons'], router.pathname) 
                ? 'text-gray-300' 
                : 'text-gray-400 group-hover:text-gray-300',
              'mr-4 flex-shrink-0 h-6 w-6'
            )}
            aria-hidden="true"
          />
          Seasons
        </a>
      </Link>
    </div>
  )
}

export default ManagerNavigation;
